import { cn } from '../../../lib/cn'

export interface DotsTopProps {
  className?: string
}

/**
 * DotsTop - Dot pattern background with top fade
 *
 * Creates a repeating dot pattern that fades from the top.
 * Uses theme variables for automatic light/dark mode support.
 *
 * Fixed fadeSize: 0.6
 *
 * @example
 * ```tsx
 * <section className="relative">
 *   <DotsTop />
 *   <div className="relative z-10">Content here</div>
 * </section>
 * ```
 */
export function DotsTop({ className }: DotsTopProps = {}) {
  const fadeSize = 0.6
  const sizeX = `${fadeSize * 100}%`
  const sizeY = `${fadeSize * 100 * 0.85}%` // Slightly shorter vertically
  const maskGradient = `radial-gradient(ellipse ${sizeX} ${sizeY} at 50% 0%, #000 60%, transparent 100%)`

  return (
    <div
      className={cn('absolute inset-0 z-0', className)}
      style={{
        backgroundImage: `radial-gradient(circle, var(--border) 1px, transparent 1px)`,
        backgroundSize: '24px 24px',
        maskImage: maskGradient,
        WebkitMaskImage: maskGradient,
      }}
    />
  )
}
